<template>
  <!--==========================
    About Us Section
  ============================-->
  <section id="about">
    <div class="container">
      <div class="row about-container">

        <!-- Text Content -->
        <div class="col-lg-6 content order-lg-1 order-2">
          <h2 class="title">About RM Software Services Ltd</h2>
          <p>
            My name is Richard Moulton and I'm a freelance IBM i developer with over 30 years of professional experience.
          </p>
          <p>
            I have extensive experience in the complete development life cycle, and have had an in-depth involvement in a vast number of projects in many industry sectors, with roles ranging from application testing to project management. There are few IT roles I haven’t performed during my career.
          </p>
          <p>
            I am extremely hard working and conscientious, and I will always put in the additional effort required to make a task, phase or project successful. The scale of projects has ranged from small bespoke modifications, to full system development and installation. As such I can comfortably work alone or as part of a team.
          </p>
          <p>
            With my vast and varied project and industry experience, I am able to bring new ideas and techniques to my clients.
          </p>
        </div>

        <!-- Background / Image / Animation -->
        <div class="col-lg-6 background order-lg-2 order-1"></div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutSection",
};
</script>
